/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useState } from "react";
import useNavbarConfig from "../hooks/useNavbarConfig";
import useFetchStrategies from "../hooks/useFetchStrategies";

const expertContext = createContext({
  isLoading: false,
  expertData: [],
  configs: {},
  strategies: [],
  expertIndicators: [],
  expertStrategyId: null,
  setExpertStrategyId: () => {},
  setExpertIndicators: () => {},
  setExpertData: () => {},
  getFilteredTimeframes: () => {},
});

export const ExpertProvider = ({ children }) => {
  const { configs } = useNavbarConfig();
  const { strategies, isLoading } = useFetchStrategies();

  const [expertData, setExpertData] = useState([]);

  const [expertIndicators, setExpertIndicators] = useState([]);
  const [expertStrategyId, setExpertStrategyId] = useState(null);

  const expertValue = {
    expertData,
    isLoading,
    setExpertData,
    expertIndicators,
    setExpertIndicators,
    configs,
    strategies,
    expertStrategyId,
    setExpertStrategyId,
  };

  return (
    <expertContext.Provider value={expertValue}>
      {children}
    </expertContext.Provider>
  );
};

export default expertContext;

export const useExpertContext = () => {
  return useContext(expertContext);
};
